import React, { useEffect, useState } from 'lib/react';
import {
  EVClear,
  EVDrawer,
  EVGrid,
  EVMenuIcon,
  EVButton,
  EVClickAwayListener,
} from 'lib/components';
import { useTranslation } from 'lib/translation';
import { isAuthorized } from 'utils/auth.utils';
import clsx from 'clsx';
import {
  PLACE_ORDER_ROUTE,
  BILLING_INFORMATION_ADD_ACH_ROUTE,
  BILLING_INFORMATION_ADD_CARD_ROUTE,
} from 'constants/RouteConstants';
import { useLocation } from 'lib/router';
import HeaderStyles from './HeaderStyles';
import { LANGUAGES } from '../../constants/AppConstants';
import useMediaQuery from '../../hooks/useMediaQuery';
import MenuItems from './components/MenuItems.component';
import BackNavigationLink from './components/BackNavigationLink.component';

function Header() {
  const isMobile = useMediaQuery(640);
  const isTablet = useMediaQuery(1024);
  const [menuOpen, setMenuOpen] = useState(false);
  const { i18n } = useTranslation();
  const classes = HeaderStyles();

  const { pathname } = useLocation();

  useEffect(() => {
    if (!LANGUAGES.some(({ id }) => id === i18n.language)) i18n.changeLanguage('en');
  }, []);

  // #genai Phase 2 add-payment-method mobile/tablet Figmas (269:21887 / 269:21702 / 269:21589) have
  // no global app chrome above the white card — the page provides its own centered "← Add Payment
  // Method" sub-header. Collapse the hamburger + back-nav strip here on those routes only; desktop
  // (below) and every other route are untouched. The white card's sub-header still owns "back" nav.
  const hideMobileChromeForAddPaymentRoutes = (
    pathname === BILLING_INFORMATION_ADD_ACH_ROUTE
    || pathname === BILLING_INFORMATION_ADD_CARD_ROUTE
  );

  if (isMobile || isTablet) {
    if (hideMobileChromeForAddPaymentRoutes) return null;
    return (
      <>
        <EVDrawer
          className={classes.drawer}
          anchor="left"
          open={menuOpen}
          hideBackdrop
          PaperProps={{
            className: clsx(classes.paper, !isAuthorized() && pathname === PLACE_ORDER_ROUTE && 'unauthorised'),
          }}
        >
          <EVClickAwayListener onClickAway={() => setMenuOpen(false)}>
            <EVGrid style={{ display: 'contents' }}>
              <MenuItems
                setMenuOpen={setMenuOpen}
              />
            </EVGrid>
          </EVClickAwayListener>
        </EVDrawer>
        <EVGrid container className={classes.header} component="header">
          <EVButton
            id="toggle-menu-btn"
            className={classes.toggleMenuBtn}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {
              menuOpen
                ? <EVClear />
                : (
                  <EVMenuIcon style={{
                    height: '35px', width: '35px', stroke: '#000000', strokeWidth: 0.5,
                  }}
                  />
                )
            }
          </EVButton>
          <BackNavigationLink />
        </EVGrid>
      </>
    );
  }

  return (
    <EVGrid container justifyContent="space-between" className={classes.header} component="header">
      <MenuItems />
    </EVGrid>
  );
}

export default Header;
